import brazilStrings from 'react-timeago/lib/language-strings/pt-br';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import enStrings from 'react-timeago/lib/language-strings/en';

const selectedLanguage = (language) => {
  switch (language) {
    case 'en':
      return enStrings;
    case 'pt_BR':
      return brazilStrings;
    default:
      return brazilStrings;
  }
};

const formatterTimer = (language) => {
  return buildFormatter(selectedLanguage(language));
};

export { formatterTimer };
